import pkg from 'package'

export default {
  theme: {
    color: 'blue darken-2',
    colorHTML: '#1976D2'
  },
  device: {
    isMobile: false,
    isTablet: false
  },
  pkg: {
    pkg: pkg
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js